import React, { useCallback, useState, useRef, useEffect } from 'react';
import axios from '../axios';
import FeedItem from '../members/feed_item';

// 使われていない
const FeedList = ({ currentUser }) => {
  const [userfeeds, setUserFeeds] = useState([]);
  const [friendsFullnames, setFriendsFullnames] = useState([]);
  const [isLoadingNextList, setIsLoadingNextList] = useState(false);
  const [isLastPage, setIsLastPage] = useState(false);
  const [page, setPage] = useState(1);
  const ancLastItemRef = useRef(null);
  const isEnableNextLoad = useRef(true);

  // スクロール時
  const loadNextList = useCallback(() => {
    if (isLoadingNextList || isLastPage) {
      return;
    }
    setIsLoadingNextList(true);
    axios.get(`/api/userfeeds?page=${page}`).then((res) => {
      setUserFeeds((prev) => [...prev, ...res.data.userfeeds]);
      setPage((prev) => prev + 1);
      setIsLoadingNextList(false);
      setIsLastPage(res.data.isLastPage);
    });
  }, [page, isLoadingNextList, isLastPage, setIsLoadingNextList]);

  const friends_fullnames = useCallback(() => {
    axios.get(`/api/user/friends/fullnames`).then((res) => {
      setFriendsFullnames((prev) => [...prev, ...res.data]);
    });
  }, []);

  useEffect(() => {
    friends_fullnames();
    loadNextList();
  }, []);

  const handleScrollEvent = useCallback(() => {
    const ancPosition = ancLastItemRef.current.offsetTop;
    const scrolled = $(window).scrollTop();
    if (
      scrolled > ancPosition - 1000 &&
      scrolled < ancPosition &&
      isEnableNextLoad.current
    ) {
      isEnableNextLoad.current = false;
      loadNextList();
    }
  }, [ancLastItemRef, isEnableNextLoad, loadNextList]);

  useEffect(() => {
    if (isLoadingNextList) {
      isEnableNextLoad.current = false;
    } else {
      isEnableNextLoad.current = true;
    }

    if (typeof window !== 'undefined') {
      if (isLastPage) {
        window.removeEventListener('scroll', handleScrollEvent);
      } else {
        window.addEventListener('scroll', handleScrollEvent);
      }

      return () => {
        window.removeEventListener('scroll', handleScrollEvent);
      };
    }
  }, [isLastPage, handleScrollEvent]);

  return (
    <React.Fragment>
      <div className="container col-md-6 col-lg-5">
        <div className="row">
          {userfeeds.map((userFeed) => (
            <FeedItem
              key={userFeed.id}
              currentUser={currentUser}
              userFeed={userFeed}
              friendsFullnames={friendsFullnames}
            />
          ))}
          {isLoadingNextList ? (
            <div className="mx-auto py-4">
              <div className="spinner-border" role="status">
                <span className="sr-only">Loading...</span>
              </div>
            </div>
          ) : (
            ''
          )}
          <div id="ancLastItem" ref={ancLastItemRef} />
        </div>
      </div>
    </React.Fragment>
  );
};

export default FeedList;
